import React from "react";
import { observer } from "mobx-react";
import InvoiceIndexPage from "~/modules/BillingCentral/app/InvoiceIndexPage";
import "../styles/SidePage.less";

const ClientPanelInvoiceIndexPage = observer(props => <InvoiceIndexPage {...props} />);

export default ClientPanelInvoiceIndexPage;
